import { useMemo, useSyncExternalStore } from "react";

export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
};

function getWidth() {
  if (typeof window === "undefined") return 0;
  return window.innerWidth || document.documentElement.clientWidth || 0;
}

function subscribe(onStoreChange) {
  if (typeof window === "undefined") return () => {};
  const onChange = () => onStoreChange();
  window.addEventListener("resize", onChange, { passive: true });
  window.addEventListener("orientationchange", onChange, { passive: true });
  window.visualViewport?.addEventListener("resize", onChange, { passive: true });
  return () => {
    window.removeEventListener("resize", onChange);
    window.removeEventListener("orientationchange", onChange);
    window.visualViewport?.removeEventListener("resize", onChange);
  };
}

export function useViewportWidth() {
  return useSyncExternalStore(subscribe, getWidth, () => 0);
}

export function useResponsive() {
  const width = useViewportWidth();
  return useMemo(
    () => ({
      width,
      isMobile: width < BREAKPOINTS.md,
      isTabletUp: width >= BREAKPOINTS.md,
      isDesktop: width >= BREAKPOINTS.lg,
      isDesktopXl: width >= BREAKPOINTS.xl,
    }),
    [width]
  );
}

export default useResponsive;
